import { createAction } from '@reduxjs/toolkit';

export const logout = createAction('logout');